module.exports = __webpack_public_path__ + "static/media/form_bg.68f84a35.jpg";